export default __webpack_public_path__ + "5ee65243ac1519d3f75378e76bb89890.webp";